import api from '.'

export async function destroyToken(): Promise<void> {
  await api.delete('/token')
  localStorage.removeItem('td-credential')
}
